import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { useAppSelector } from "integrations/redux/hooks"
import { selectOrthoImagesAndUploadsByFlightId } from "features/entity-caching/images/orthos/selectors"
import { GenericUpload, SidePanelLayer } from "@nova/constants"
import { useDownloadButtonData } from "plugins/Orthomosaic/useOrthomosaicDownloadButtonData"
import { InspectorPanelMetadata } from "../FlightPanelMetadata"
import { InspectorPanelAccordionIntegrations } from "../accordion/integrations/InspectorPanelAccordionIntegrations"
import { selectOrthoFlightById } from "features/entity-caching/flights/selectors"

const emptyUploads = [] as never[]

export const InspectorPanelOrthoData = ({ id }: { id: string }) => {
    const flight = useAppSelector(selectOrthoFlightById(id))
    const uploads = useAppSelector(selectOrthoImagesAndUploadsByFlightId(id))
    const completedUploadCount = flight.images.length
    const downloadOptions = useDownloadButtonData(uploads || emptyUploads)

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            {/* Integrations */}
            <InspectorPanelAccordionIntegrations
                id={id}
                integrationOptions={downloadOptions.integrationOptions}
            />

            <InspectorPanelMetadata
                entity={flight as SidePanelLayer}
                uploads={uploads as GenericUpload[]}
                completedUploadCount={completedUploadCount}
            />
        </div>
    )
}
